import React from 'react'
import Card from "../Components/cards/Cards"

const Training = () => {
  return (
    <div className='bg-[#F5F7F8] h-fit w-full '>
        
        <div className=''>
        <Card></Card>
        </div>
        <div className='text-[75px] font-extrabold  text-center text-blue'>
            Reviews
        </div>
        
    </div>
  )
}

export default Training